import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { COLOR_LIST } from "../../constants/constants";
import {encode as base64_encode, decode as base64_decode} from 'base-64';
import Header from "../Header";
import Footer from "../Footer";
import Sidebar from "../Sidebar";
import CalendarInfo from "./CalendarInfo";
import EditCalendarInfo from './EditCalendarInfo';
import { useParams } from "react-router-dom";
import client from "../../api";
import { notifyError, notifySuccess } from "../../helper";
import CalendarTable from "./CalendarTable";

const CampaignCalendar = () => {
    const api = client();
    const {emailAddress} = useParams('');
    const [legends, setLegends] = useState([]);
    const [editMode, setEditMode] = useState(false);
    const [calendarData,setCalendarData] = useState({});
    const [weekDates, setWeekDates] = useState([]);
    const setLegendData = (data) => {
        const campaigns = data.data.campaign;
        const colorCodes = Object.keys(campaigns).map((row,i)=>{
            const prepareLegend = {
                id: row,
                name:campaigns[row],
                colorCode:COLOR_LIST[i]
            }
            return (prepareLegend);
        });
        setLegends(colorCodes);
    }

    const getDatesForTwoWeeks = () => {
        const DATA_DURATION = 7;
        const currentDate = new Date();
        // Get the current day of the week (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
        const currentDay = currentDate.getDay();
        
        // Calculate the date of the most recent Sunday (or today if it's Sunday)
        const sundayDate = new Date(currentDate);
        sundayDate.setDate(currentDate.getDate() - currentDay); // Go back to the previous Sunday
        
        // Generate an array of dates for 2 weeks (14 days)
        const dates = [];
        for (let i = 0; i < DATA_DURATION; i++) {
          const newDate = new Date(sundayDate);
          newDate.setDate(sundayDate.getDate() + i); // Add i days to Sunday
          dates.push(newDate.toISOString().split('T')[0]); // Format to YYYY-MM-DD
        }
        if(DATA_DURATION === 7){
            return {weeks:[[...dates.slice(0, 7)]],to_date:dates[dates.length-1]};
        } else {
            return {weeks:[[...dates.slice(0, 7)],[...dates.slice(7, 14)]],to_date:dates[dates.length-1]};
        }        
    };

    const prepareCalendarData = (data) => {
        const updatedItems = Object.keys(data.campaign).map((row,i)=>{
            const item = {[row]: COLOR_LIST[i]
            }
            return item;
        });
        // Convert array to object
        const colorCodes = updatedItems.reduce((acc, curr) => {
            return { ...acc, ...curr };
        }, {});

        setCalendarData({...data,legends:{...colorCodes}});
        
    };

    useEffect(() => {
        const checkAndRedirect = async () => {
            if (!emailAddress) {
                try {
                    const response = await api.get('/v1/mailAccount/list');
                    if(response.status === 200 || response.status === 201){
                        let email = response.data.data[0].email;
                        window.location.href = `/campaign/calendar/${base64_encode(email)}`;
                    }
                } catch (err) {
                    console.error("Error fetching data:", err);
                }
            } else {
                const weeks = getDatesForTwoWeeks();
                // /const weekDates = weeks.weeks;
                setWeekDates(weeks.weeks);
                try{
                    //const response = await setStates()
                    const response = await api.post('/v1/mailAccount/calendar',{ 
                        email: base64_decode(emailAddress), 
                        to_date : weeks.to_date
                    });
                    if(response.status === 200 || response.status === 201){
                        //console.log('response.data',response.data);
                        setLegendData(response.data);
                        prepareCalendarData(response.data.data);                        
                    }
                } catch (error) {
                    console.log('error.message',error);
                    if(error.status === 400) notifyError('Bad Request. Unable to fetch Campaign Calendar data. Please try again.');
                }
            }
        };
        checkAndRedirect();
    }, [editMode]);

    return(<>
        <Header/>
        <div className="main-page">
            <Sidebar/>
            <div className="calendar-pages-wrap">
                <div className="top-section">
                        <h1>Mail Sending Calendar </h1>                    
                </div>
                <div className="middle-section">
                    <div className="account-info-box">
                        <div className="account-info">
                        {editMode ? <EditCalendarInfo email={emailAddress}  setEditMode = {(editMode)=>{setEditMode(editMode)}}  /> : <CalendarInfo email={emailAddress} setEditMode = {(editMode)=>{setEditMode(editMode)}}  />}
                        </div>
                        <div className="legend-info">
                            <h3>Active campaign legend</h3>
                            <ul>
                            {legends.map((row,i)=>(<li key={i} title={row.name}>
                                    <span className="color-dot" style={{background:row.colorCode}}></span>
                                    <span className="legend-title">{row.name}</span>
                                    <Link to={`/campaign/${row.id}/overview`} className="legend-link"><i className='bx bx-link' ></i></Link>
                                </li>))}                                
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="bottom-section">
                    <div className="info">
                        <p>This is an estimate. Actual times may change by recipient actions, pending changes, etc.</p>
                    </div>
                    {weekDates.map((week, index) => (
                        <CalendarTable key={index} weekDays = {week} index={index} calendarData={calendarData} />
                    ))}
               </div>
            </div>
        </div>
        <Footer/>
    </>);
}

export default CampaignCalendar;